/* GoClove PLP — Core: Config, selectors, utilities
   Shared namespace: window.__GOC_PLP__
*/
(function () {
  if (window.__GOC_PLP_CORE__) return;
  window.__GOC_PLP_CORE__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;

  // Labels — populated from Liquid data-gocplp-state JSON
  window.__GOC_LABELS__ = window.__GOC_LABELS__ || {
    showFilters: "Show Filters",
    hideFilters: "Hide Filters",
    filters: "Filters",
    sort: "Sort",
    apply: "Apply",
    clear: "Clear",
    loading: "Loading…",
    loadMore: "Load more",
    quickAdd: "Quick Add",
    selectSize: "SELECT A SIZE",
    addToCart: "ADD TO CART",
    size: "Size",
    womens: "WOMEN",
    mens: "MEN",
    noSizeChart: "No size chart.",
    sizeChartError: "Could not load size chart.",
    styleTagPrefix: "style_clove ",
    defaultStyle: "classic",
    sizeChartView: "size-chart",
    noSwatchIdentifier: "cloveys",
    noSwatchCssClass: "gpcard--no-swatches",
    genderTags: { mens: ["gender_men", "mens", "men"], womens: ["gender_women", "womens", "women"] },
    styleExceptions: ["wide"],
    sectionHandle: "goc-plp-main"
  };

  function loadLabelsFromState() {
    const el = document.querySelector("[data-gocplp-state]");
    if (!el) return;
    try {
      const data = JSON.parse(el.textContent || "{}");
      if (data.labels) Object.assign(window.__GOC_LABELS__, data.labels);
    } catch (e) {}
  }

  const LABELS = window.__GOC_LABELS__;

  const SELECTORS = {
    section: ".gocplp, [data-goc-plp]",
    drawer: "[data-goc-drawer]",
    openBtn: "[data-goc-open]",
    closeBtn: "[data-goc-close]",
    grid: "[data-goc-grid]",
    infiniteWrap: "[data-goc-infinite]",
    loadBtn: "[data-goc-load]",
    loader: "[data-goc-loader]",
    card: "[data-gpcard]",
    swatch: ".gpcard__swatch[data-sp-handle]",
    qaQuickMobile: "[data-gpcard-quick]",
    sizesWrap: "[data-gpcard-sizes]",
    sizeBtn: ".gpcard__sizeBtn",
    swiper: "[data-gpcard-swiper]"
  };

  const qs = (root, sel) => (root || document).querySelector(sel);
  const qsa = (root, sel) => Array.from((root || document).querySelectorAll(sel));

  function parseTagsAny(input) {
    if (Array.isArray(input)) return input.map(t => String(t || "").trim()).filter(Boolean);
    if (typeof input === "string") return input.split(",").map(s => s.trim()).filter(Boolean);
    return [];
  }

  function decodeVariants(encoded) {
    if (!encoded) return [];
    try { return JSON.parse(decodeURIComponent(encoded)); } catch (e) { return []; }
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

  function cssEscapeAttr(s) {
    return String(s || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function getCssGapPx(el, fallback) {
    try {
      const cs = window.getComputedStyle(el);
      const gap = cs.columnGap || cs.gap || "";
      const n = parseFloat(gap);
      return Number.isFinite(n) ? n : (fallback || 0);
    } catch (e) { return fallback || 0; }
  }

  // Expose on shared namespace
  Object.assign(GOC, {
    LABELS, SELECTORS, qs, qsa,
    loadLabelsFromState,
    parseTagsAny, decodeVariants, escapeHtml, cssEscapeAttr, getCssGapPx
  });
})();
